import classNames from 'classnames'
import { t } from 'i18next'
import { Dropdown } from 'primereact/dropdown'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Person } from '../../../../../model/person.model'
import { useAppSelector } from '../../../../../redux/hooks'
import { findPersonById } from '../../../../../util/arraySearch'
import { AvatarWithName } from '../../../AvatarWithName'
import { getFormErrorMessage } from '../../../ErrorText'

export const AllPeopleDropdown = (props: {
  isDisabled?: boolean;
  fieldName: string;
  excludedPeople?: number[];
  required? : boolean
}): JSX.Element => {
  const people: any[] = useAppSelector((state) => {
    const theSet = new Set(props.excludedPeople)
    return state.apprentices
      .concat(state.employees)
      .filter(
        (person: Person) => person?.person_id && !theSet.has(person.person_id)
      )
  })

  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext()

  const selectedPersonTemplate = (personId: number | undefined) => {
    if (personId && personId > 0) {
      const person = findPersonById(personId, people)
      if (person) {
        return <AvatarWithName person={person} />
      }
      console.warn(
        `[All People Dropdown] Person with ID '${personId}' in selected but not found.`
      )
    }

    return (
      <span className={'dropdown-avatar'}>{t<string>('core.select')}</span>
    )
  }

  const personOptionTemplate = (person: Person) => {
    if (person.is_active !== 1) {
    }
    return <AvatarWithName person={person} />
  }

  return (
    <>
      {props?.fieldName === 'id_person' && (
        <label htmlFor={props.fieldName}>{t<string>('core.person')}</label>
      )}
      <Controller
        name={props.fieldName}
        control={control}
        rules={{validate: (v) => !props.required || v > 0}}
        render={({ field, fieldState }) => (
          <Dropdown
            id={field.name}
            appendTo={document.body}
            options={people}
            onChange={(e) => {
              // we have the apprentice object and want to set the id
              field.onChange(e.target.value?.person_id)
              setValue(field.name, e.target.value?.person_id, {
                shouldDirty: true,
              })
            }}
            optionLabel="full_name"
            placeholder={t<string>('core.select')}
            filter
            showClear={true}
            filterBy="full_name"
            valueTemplate={selectedPersonTemplate(field.value)}
            itemTemplate={personOptionTemplate}
            className={classNames(
              { 'p-invalid': fieldState.error },
              ' w-full people-dropdown'
            )}
            emptyMessage={t<string>('core.empty_message')}
            emptyFilterMessage={t<string>('core.empty_filter_message')}
            disabled={props?.isDisabled}
          />
        )}
      />
      {getFormErrorMessage(errors, props.fieldName)}
    </>
  )
}